import { get } from './helpers/generator';
import { addRule, getAttributes } from './helpers/rules';
import operations from './operations';

export default {
  generator: {
    addRule,
    get,
    getAttributes,
  },
  operations,
};
